import { render, staticRenderFns } from "./report-edit-general.vue?vue&type=template&id=babe1e58"
import script from "./report-edit-general.vue?vue&type=script&lang=ts"
export * from "./report-edit-general.vue?vue&type=script&lang=ts"
import style0 from "./report-edit-general.vue?vue&type=style&index=0&id=babe1e58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports